(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var R = window.routes || {};

  function money(cents) {
    var f = window.moneyFormat || 'Rs.{{amount}}';
    var n = cents / 100;
    var amt = n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      return k === 'amount_no_decimals' ? Math.round(n).toLocaleString('en-US') : amt;
    });
  }

  /* ---------- Cart ---------- */
  function openDrawer() {
    var d = $('[data-cart-drawer]');
    if (!d) { location.href = R.cart; return; }
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    var d = $('[data-cart-drawer]'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll');
  }
  function refreshCart(open) {
    return fetch(R.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (json) {
      var doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
      var fresh = $('[data-cart-drawer-inner]', doc), cur = $('[data-cart-drawer-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      initTrackers();
      return fetch(R.cartJs).then(function (r) { return r.json(); });
    }).then(function (c) {
      $$('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; e.hidden = c.item_count === 0; });
      if (open) openDrawer();
    });
  }
  function addItems(items) {
    return fetch(R.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); });
      return r.json();
    });
  }
  function changeLine(line, qty) {
    return fetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { return refreshCart(false); });
  }

  /* ---------- Click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('[data-quick-add]'))) {
      el.disabled = true; var old = el.textContent; el.textContent = 'Adding…';
      addItems([{ id: parseInt(el.dataset.quickAdd, 10), quantity: 1 }])
        .then(function () { return refreshCart(true); })
        .catch(function (err) { alert(err.message); })
        .then(function () { el.disabled = false; el.textContent = old; });
      return;
    }
    if ((el = t.closest('[data-cart-open]'))) { if ($('[data-cart-drawer]')) { e.preventDefault(); openDrawer(); } return; }
    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }
    if ((el = t.closest('[data-line-qty]'))) {
      e.preventDefault();
      changeLine(parseInt(el.dataset.line, 10), Math.max(0, parseInt(el.dataset.qty, 10)));
      return;
    }
    if (t.closest('[data-nav-toggle]')) {
      $('[data-nav]').classList.toggle('is-open'); $('.nav-overlay').classList.toggle('is-open');
      document.body.classList.toggle('no-scroll'); return;
    }
    if (t.closest('[data-search-toggle]')) {
      var s = $('[data-search]'); s.hidden = !s.hidden; if (!s.hidden) $('input', s).focus(); return;
    }
    if ((el = t.closest('[data-qty-step]'))) {
      var input = $('input', el.parentNode);
      var min = input.min === '0' ? 0 : 1, cur = parseInt(input.value, 10); if (isNaN(cur)) cur = min;
      input.value = Math.max(min, cur + parseInt(el.dataset.qtyStep, 10));
      return;
    }
    if (t.closest('[data-filter-toggle]')) { var f = $('[data-filters]'); f.hidden = !f.hidden; return; }
    if ((el = t.closest('[data-buy-now]'))) {
      var form = el.closest('form'); if (!form) return;
      el.disabled = true;
      addItems([{ id: parseInt($('[name=id]', form).value, 10), quantity: parseInt($('[name=quantity]', form).value, 10) || 1 }])
        .then(function () { location.href = R.checkout; })
        .catch(function (err) { showError(form, err.message); el.disabled = false; });
      return;
    }
    if ((el = t.closest('[data-vr-nav]'))) {
      var row = $('[data-vr]', el.closest('.vr')); row.scrollBy({ left: parseInt(el.dataset.vrNav, 10) * row.clientWidth * 0.8, behavior: 'smooth' }); return;
    }
    if ((el = t.closest('[data-vcard]'))) {
      var vid = $('video', el); if (!vid) return;
      if (vid.paused) {
        $$('[data-vcard] video').forEach(function (v) { v.pause(); v.closest('[data-vcard]').classList.remove('is-playing'); });
        vid.muted = false; var pr = vid.play(); if (pr && pr.catch) pr.catch(function () { vid.muted = true; vid.play(); });
        el.classList.add('is-playing');
      } else { vid.pause(); el.classList.remove('is-playing'); }
      return;
    }
    if ((el = t.closest('[data-thumb]'))) {
      var track = $('[data-track]'); track.scrollTo({ left: track.clientWidth * parseInt(el.dataset.thumb, 10), behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function showError(form, msg) {
    var p = $('[data-form-error]', form); if (!p) return alert(msg);
    p.textContent = msg; p.hidden = false;
  }

  /* ---------- Product form submit (add to cart) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-product-form]') : null;
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-atc]:not([data-buy-now])', form);
    if (btn) btn.disabled = true;
    addItems([{ id: parseInt($('[name=id]', form).value, 10), quantity: parseInt($('[name=quantity]', form).value, 10) || 1 }])
      .then(function () { var p = $('[data-form-error]', form); if (p) p.hidden = true; return refreshCart(true); })
      .catch(function (err) { showError(form, err.message); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Sort & filters ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest ? e.target.closest('[data-sort]') : null;
    if (s) { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); }
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var data = JSON.parse($('[data-product-json]', root).textContent);
    var stock = {}; try { stock = JSON.parse($('[data-stock]', root).textContent); } catch (e) {}
    var idInput = $('[data-variant-id]', root);
    var track = $('[data-track]', root);

    function update() {
      var sel = $$('[data-option]:checked', root).map(function (i) { return i.value; });
      $$('fieldset.opt', root).forEach(function (fs) {
        var c = $('[data-option]:checked', fs), l = $('[data-opt-label]', fs); if (c && l) l.textContent = c.value;
      });
      var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      var btns = $$('[data-atc]', root);
      if (!v) { btns.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; }); return; }
      idInput.value = v.id;
      $$('[data-price]', root).forEach(function (p) { p.textContent = money(v.price); });
      var on = v.compare_at_price && v.compare_at_price > v.price;
      var cmp = $('[data-compare]', root), sv = $('[data-save]', root), bd = $('[data-badge]', root);
      if (cmp) { cmp.hidden = !on; if (on) cmp.textContent = money(v.compare_at_price); }
      if (on) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        if (sv) { sv.hidden = false; sv.textContent = 'Save ' + pct + '%'; }
        if (bd) { bd.hidden = false; bd.textContent = '-' + pct + '%'; }
      } else { if (sv) sv.hidden = true; if (bd) bd.hidden = true; }
      btns.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? b.dataset.label : 'Sold out'; });
      var q = stock[v.id], msg = $('[data-stock-msg]', root);
      if (msg) { if (v.available && q > 0 && q <= 10) { msg.hidden = false; msg.textContent = 'Hurry! Only ' + q + ' left in stock'; } else msg.hidden = true; }
      var ts = $('[data-t-stock]', root); if (ts) ts.hidden = !v.available;
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      if (v.featured_image && track) {
        var pos = v.featured_image.position - 1;
        track.scrollTo({ left: track.clientWidth * pos, behavior: 'smooth' });
      }
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-option]')) update(); });

    // thumbs highlight on swipe
    if (track) {
      var thumbs = $$('[data-thumb]', root);
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }

    // sticky mobile bar appears after the main buttons scroll away
    var bar = $('[data-sticky-bar]', root), anchor = $('[data-buy-now]', root);
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var gone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', gone);
      }).observe(anchor);
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- Related products ---------- */
  $$('[data-recs-url]').forEach(function (box) {
    fetch(box.dataset.recsUrl).then(function (r) { return r.text(); }).then(function (html) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-recs');
      if (el && el.innerHTML.trim().length) box.innerHTML = el.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Delivery tracker (Pakistan time) ---------- */
  function initTrackers() {
    $$('[data-tracker]').forEach(function (el) {
      var cut = +el.dataset.cutoff, dd = +el.dataset.dispatch, mn = +el.dataset.min, mx = +el.dataset.max, skip = el.dataset.skipsun === 'true';
      var p = {};
      try {
        new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Karachi', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
          .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      } catch (e) { return; }
      var base = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
      var mins = (+p.hour % 24) * 60 + (+p.minute);
      var after = mins >= cut * 60;
      function addDays(d, n) { var r = new Date(d.getTime()); while (n > 0) { r.setUTCDate(r.getUTCDate() + 1); if (!(skip && r.getUTCDay() === 0)) n--; } return r; }
      function fixSun(d) { return (skip && d.getUTCDay() === 0) ? new Date(d.getTime() + 86400000) : d; }
      var start = after ? addDays(base, 1) : fixSun(base);
      var dispatch = addDays(start, dd), dMin = addDays(dispatch, mn), dMax = addDays(dispatch, mx);
      function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).replace(',', ''); }
      function rel(d) { var n = Math.round((d - base) / 86400000); return n === 0 ? 'Today' : n === 1 ? 'Tomorrow' : fmt(d); }
      function relFull(d) { var r = rel(d); return (r === 'Today' || r === 'Tomorrow') ? r + ', ' + fmt(d) : r; }
      function set(k, v) { var x = $('[data-t-' + k + ']', el); if (x) x.textContent = v; }
      set('order', 'Today, ' + fmt(base));
      set('dispatch', relFull(dispatch));
      var range = mn === mx ? fmt(dMin) : fmt(dMin) + ' – ' + fmt(dMax);
      set('deliver', range); set('eta', range);
      var note = $('[data-t-cutoff]', el);
      if (note) {
        if (!after && dd <= 1 && !(skip && base.getUTCDay() === 0)) {
          var left = cut * 60 - mins, h = Math.floor(left / 60), m = left % 60;
          note.textContent = 'Order within ' + (h > 0 ? h + ' hr ' : '') + m + ' min to get it dispatched ' + rel(dispatch).toLowerCase() + '.';
          note.hidden = false;
        } else { note.hidden = true; }
      }
    });
  }
  initTrackers();

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) { el.hidden = true; return; }
    var timer;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function set(k, v) { var x = $('[data-cd="' + k + '"]', el); if (x) x.textContent = v; }
    function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.hidden = true; clearInterval(timer); return; }
      var s = Math.floor(d / 1000);
      set('d', pad(Math.floor(s / 86400))); set('h', pad(Math.floor(s % 86400 / 3600)));
      set('m', pad(Math.floor(s % 3600 / 60))); set('s', pad(s % 60));
    }
    timer = setInterval(tick, 1000); tick();
  });
})();
